import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Navigation = ({ currentPage = 'home', mobileOpen, setMobileOpen, servicesOpen, setServicesOpen, mobileServicesOpen, setMobileServicesOpen }) => {

  // Close desktop submenu on outside click or ESC
  useEffect(() => {
    const onDocClick = (e) => {
      const nav = document.querySelector('.header .nav');
      if (!nav) return;
      const hasSub = nav.querySelector('li.has-sub');
      if (hasSub && !hasSub.contains(e.target)) setServicesOpen(false);
    };
    const onKey = (e) => { if (e.key === 'Escape') setServicesOpen(false); };
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKey);
    return () => { document.removeEventListener('click', onDocClick); document.removeEventListener('keydown', onKey); };
  }, [servicesOpen, setServicesOpen]);

  const isActive = (path) => {
    if (path === 'home') return currentPage === 'home';
    if (path === 'portfolio') return currentPage === 'portfolio';
    if (path === 'about') return currentPage === 'about' || currentPage === 'tentang';
    if (path === 'client') return currentPage === 'client';
    if (path === 'consultation') return currentPage === 'consultation';
    if (path === 'google-ads') return currentPage === 'google-ads';
    if (path === 'services') return currentPage === 'services';
    if (path === 'website-maintenance') return currentPage === 'website-maintenance';
    if (path === 'blog') return currentPage === 'blog';
    return false;
  };

  return (
    <>
      {/* Desktop Navigation - Semua menu lengkap */}
      <nav className="nav desktop-nav">
        <ul>
          <li className={isActive('home') ? 'active' : ''}>
            <Link to="/" onClick={() => setMobileOpen(false)}>Beranda</Link>
          </li>
          <li className={isActive('about') ? 'active' : ''}>
            <Link to="/tentang" onClick={() => setMobileOpen(false)}>Tentang Kami</Link>
          </li>
          <li className="has-sub">
            <button
              type="button"
              className="submenu-toggle"
              aria-expanded={servicesOpen}
              onClick={() => setServicesOpen(!servicesOpen)}
            >
              Layanan
              <svg className="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <ul className={`submenu ${servicesOpen ? 'open' : ''}`}>
              <li><Link to="/services" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>All Services</Link></li>
              <li><Link to="/services#software-engineering" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>Software Engineering</Link></li>
              <li><Link to="/services#ai-automation" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>AI & Automation</Link></li>
              <li><Link to="/services#cloud-solutions" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>Cloud Solutions</Link></li>
              <li><Link to="/services#digital-visibility" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>Digital Visibility</Link></li>
              <li><Link to="/services#managed-it" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>Managed IT Services</Link></li>
              <li><Link to="/website-maintenance" onClick={() => { setServicesOpen(false); setMobileOpen(false); }}>Website Maintenance</Link></li>
            </ul>
          </li>
          <li className={isActive('portfolio') ? 'active' : ''}>
            <Link to="/portfolio" onClick={() => setMobileOpen(false)}>Portfolio</Link>
          </li>
          <li className={isActive('blog') ? 'active' : ''}>
            <Link to="/blog" onClick={() => setMobileOpen(false)}>Artikel</Link>
          </li>
          <li className={isActive('client') ? 'active' : ''}>
            <Link to="/client" onClick={() => setMobileOpen(false)}>Klien</Link>
          </li>
          <li className={isActive('consultation') ? 'active' : ''}>
            <Link to="/consultation" onClick={() => setMobileOpen(false)}>Kontak</Link>
          </li>
        </ul>
      </nav>
      
      {/* Mobile Navigation - Semua menu lengkap */}
      <div
        id="mobile-nav"
        className={`mobile-nav ${mobileOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        onClick={(e) => { if (e.target.id === 'mobile-nav') setMobileOpen(false); }}
      >
        <ul>
          <li>
            <Link to="/" onClick={() => setMobileOpen(false)}>Beranda</Link>
          </li>
          <li>
            <Link to="/tentang" onClick={() => setMobileOpen(false)}>Tentang Kami</Link>
          </li>
          <li className="has-sub">
            <button
              type="button"
              className="submenu-toggle"
              aria-expanded={mobileServicesOpen}
              onClick={() => setMobileServicesOpen(!mobileServicesOpen)}
            >
              Layanan
              <svg className="dropdown-arrow" width="12" height="8" viewBox="0 0 12 8" fill="none">
                <path d="M1 1.5L6 6.5L11 1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <ul className={`submenu ${mobileServicesOpen ? 'open' : ''}`}>
              <li><Link to="/services" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>All Services</Link></li>
              <li><Link to="/services#software-engineering" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>Software Engineering</Link></li>
              <li><Link to="/services#ai-automation" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>AI & Automation</Link></li>
              <li><Link to="/services#cloud-solutions" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>Cloud Solutions</Link></li>
              <li><Link to="/services#digital-visibility" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>Digital Visibility</Link></li>
              <li><Link to="/services#managed-it" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>Managed IT Services</Link></li>
              <li><Link to="/website-maintenance" onClick={() => { setMobileServicesOpen(false); setMobileOpen(false); }}>Website Maintenance</Link></li>
            </ul>
          </li>
          <li>
            <Link to="/portfolio" onClick={() => setMobileOpen(false)}>Portfolio</Link>
          </li>
          <li>
            <Link to="/blog" onClick={() => setMobileOpen(false)}>Artikel</Link>
          </li>
          <li>
            <Link to="/client" onClick={() => setMobileOpen(false)}>Klien</Link>
          </li>
          <li>
            <Link to="/consultation" onClick={() => setMobileOpen(false)}>Kontak</Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Navigation;
